export default "<div (click)=\"presentPopover($event)\" class=\"white burger-btn\" size=\"large\"></div>\n";